export const TOGGLE_IS_DEACTIVATED = 'TOGGLE_IS_DEACTIVATED'
export const TOGGLE_IS_PRIVATE = 'TOGGLE_IS_PRIVATE'
export const EDIT_PREFERRED_LANGUAGE = 'EDIT_PREFERRED_LANGUAGE'
export const ADD_TOPIC = 'ADD_TOPIC'
export const DELETE_TOPIC = 'DELETE_TOPIC'
export const FLAG_PREFERENCES_ERRORS = 'FLAG_PREFERENCES_ERRORS'
export const UNFLAG_PREFERENCES_ERRORS = 'UNFLAG_PREFERENCES_ERRORS'
export const SUBMIT_PREFERENCES_SUCCESS = 'SUBMIT_PREFERENCES_SUCCESS'
export const SUBMIT_PREFERENCES_FAIL = 'SUBMIT_PREFERENCES_FAIL'